<template>
  <div id="creek-content-page-container">
    <div v-if="API.Show == null" v-html="Creek.config.shows.router.loadingHTML"></div>
    <div class="creek-page-content" v-if="API.Show !== null">
      <div class="creek-show-info">
        <img class="creek-show-image" :src="API.Show.relationships.image.attributes.url_md" />
        <h1 class="creek-show-title" v-text="API.Show.attributes.title"></h1>
        <div class="creek-show-description" v-html="API.Show.attributes.full_description"></div>
        <div class="creek-show-hosts-container" v-if="API.Show.relationships.hosts && API.Show.relationships.hosts.length">
          <h3>Hosts</h3>
          <ul class="creek-show-hosts">
            <li v-for="Host in API.Show.relationships.hosts">
              <a v-text="Host.attributes.display_name"></a>
              <!--<img class="creek-show-image" :src="Host.relationships.image.attributes.url_md" />-->
            </li>
          </ul>
        </div>
        <div class="creek-show-airtimes-container" v-if="API.Show.relationships.airtimes && API.Show.relationships.airtimes.length">
          <!-- <h3>Airtimes</h3> -->
          <ul class="creek-show-airtimes">
            <li v-for="Airtime in API.Show.relationships.airtimes" v-if="Airtime.attributes.weekday">
              <span class="creek-airtime-weekday" v-text="convertWeekday(Airtime.attributes.weekday)"></span>
              <span class="creek-airtime-connector-word">at</span>
              <span class="creek-airtime-time" v-text="fecha.format(fecha.parse(Airtime.attributes.start, 'YYYY-MM-DD HH:mm:ss'), 'h:mma')"></span>
            </li>
          </ul>
        </div>
        <creek-social-buttons :data-link="API.Show.links.share"></creek-social-buttons>
      </div>
      <div class="creek-broadcasts-container">
        <div v-if="API.Broadcasts == null" v-html="Creek.config.shows.router.loadingHTML"></div>
        <div class="creek-broadcast" v-for="Broadcast in API.Broadcasts" :key="'broadcast-'+Broadcast.id" v-if="Broadcast.attributes.title">
          <div class="creek-broadcast-inner">
            <a class="creek-broadcast-title" v-text="Broadcast.attributes.title" :href="'#/broadcasts/'+Broadcast.id"></a>
            <creek-audio-player-mini :show="API.Show" :media="Broadcast.relationships.media" :broadcast="Broadcast"></creek-audio-player-mini>
            <a class="creek-broadcast-more-link" v-if="Broadcast.attributes.text" :href="'#/broadcasts/'+Broadcast.id">Read more</a>
            <a v-if="Broadcast.relationships.playlist !== null" class="creek-broadcast-playlist-link" :href="'#/broadcasts/'+Broadcast.id">Playlist <span class="creek-broadcast-playlist-count" v-text="Broadcast.relationships.playlist.length"></span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import JSONP from 'jsonp';

import CreekAudioPlayerMini from './AudioPlayerMini';
import CreekSocialButtons from './SocialButtons';

export default {
  name: 'creek-page-show',
  mixins: [mixins.routes],
  data () { 
    return { 
      API: {
        Show: null,
        Broadcasts: null
      }
    } 
  },
  components: {
    'creek-audio-player-mini': CreekAudioPlayerMini,
    'creek-social-buttons': CreekSocialButtons
  },
  created () {
    this.fetchData();
  },
  methods: {
    convertWeekday(weekdayNumber){
      var weekdays = [
        'Mondays',
        'Tuesdays',
        'Wednesdays',
        'Thursdays',
        'Fridays',
        'Saturdays',
        'Sundays',
      ];
      // Subtract 1, because PHP starts weekdays at 1, not 0
      return weekdays[weekdayNumber - 1];
    },
    fetchData () {
      
      var _this = this;

      var url = this.Creek.config.content.baseURLForAPI
        + "/api/v2/shows/" 
        + this.$route.params.short_name;

      JSONP(url, null, function(err, data) {
        _this.Creek.debug.log("Received data for Show.");
        _this.API.Show = data.data;
        _this.setTitle(data.data.attributes.title);
      })
      
      var url2 = this.Creek.config.content.baseURLForAPI
        + "/api/v2/broadcasts" 
        // + "/api/v2/broadcasts" 
        + "?show="+this.$route.params.short_name

      JSONP(url2, null, function(err, data) {
        _this.Creek.debug.log("Received data for Show's Broadcasts.");
        _this.API.Broadcasts = data.data;
      })

      this.swapPageClass("show creek-page-show-"+this.$route.params.short_name);

    }
  }
}
</script>